import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

// Read URL params once, synchronously — avoids extra renders from default → real value
function getInitialClient() {
  const urlParams = new URLSearchParams(window.location.search);
  const fromQuery = urlParams.get('client');
  if (fromQuery) return fromQuery;

  const pathSegments = window.location.pathname.split('/');
  const fromPath = pathSegments.find(segment => segment && segment !== '');
  if (fromPath) return fromPath;

  return 'salinas-somos'; // fallback default
}

function getInitialUserId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('UserID') || null;
}

export const UserProvider = ({ children }) => {
  const [clientName, setClientName] = useState(getInitialClient);
  const [userId, setUserId] = useState(getInitialUserId);

  const value = {
    clientName,
    setClientName,
    userId,
    setUserId
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};
